import { render, staticRenderFns } from "./ProductHighlights.vue?vue&type=template&id=03592cd0&scoped=true"
import script from "./ProductHighlights.vue?vue&type=script&lang=ts"
export * from "./ProductHighlights.vue?vue&type=script&lang=ts"
import style0 from "./ProductHighlights.vue?vue&type=style&index=0&id=03592cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03592cd0",
  null
  
)

export default component.exports